import dealer from './dealer';

export default {
  ...dealer,

  getUserInfo(state, getters) {
    return state.userInfo;
  },

  getConfigAccess(state) {
    return state.configAccess;
  },

  getUserId(state, getters) {
    const userInfo = getters.getUserInfo;
    return userInfo ? userInfo.id : null;
  },

  getConfigHideBlocksPriceOpt(state) {
    return state.config.hide_blocks.price.opt ?? false;
  },

  getDealerNotifications(state) {
    const user = state.userInfo;
    return user ? user.unviewed_count : 0;
  },

  getParentDealer(state, getters) {
    const dealer = getters.getDealer;
    return dealer ? dealer.parent_dealer : null;
  },

  hasDealerParent(state, getters) {
    return !!getters.getParentDealer;
  },

  getUserName(state, getters) {
    return getters.getUserInfo && getters.getUserInfo.name ? getters.getUserInfo.name : '';
  },

  getUserMaxDiscount(state, getters) {
    const user = state.userInfo;
    return user ? user.max_discount : 0;
  },

  getDiscountZgi(state, getters) {
    const dealer = getters.getDealer;
    return dealer ? dealer.show_discount.zgi : null;
  },

  getDiscountOpt(state, getters) {
    const dealer = getters.getDealer;
    return dealer ? dealer.show_discount.opt : null;
  },

  getConfigHideBlocksPriceZgi(state) {
    return state.config.hide_blocks.price.zgi ?? false;
  },

  getIsNoHideBlocksBasket(state, getters) {
    return !state.config?.hide_blocks?.basket;
  },

  getUserAuth(state) {
    return state.userAuth;
  },

  getCompanies(state) {
    return state.companies
  }
};
